import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import routes from '../../../constants/routes';
import styled from 'styled-components';
import { trackEvent } from '../../../services/analytics';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
`;

const Card = styled.div`
  text-align: center;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0 0 1rem 0;
`;

const Message = styled.p`
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
`;

export const BillingCancel: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent('billing_cancel_view');
    const timer = setTimeout(() => {
      navigate(routes.LANDING, { replace: true });
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container>
      <Card>
        <Title>checkout cancelled</Title>
        <Message>redirecting to terminal...</Message>
      </Card>
    </Container>
  );
};
